//event form validations
export const validateEventName = (value) => {
  if (!value || !value.trim()) {
    return "Event Name is required";
  }
  if (value.trim().length < 3) {
    return "Event Name must be at least 3 characters";
  }
  if (value.trim().length > 100) {
    return "Event Name must be less than 100 characters";
  }
  return "";
};

export const validateEventType = (value) => {
  if (!value || value === "" || value === "Choose incident category") {
    return "Event Type is required";
  }
  return "";
};

export const validateSourceSystem = (value) => {
  if (!value || !value.trim()) {
    return "Source System is required";
  }
  return "";
};

export const validateSeverityLevel = (value) => {
  if (!value || value === "Select Severity") {
    return "Severity Level is required";
  }
  return "";
};

export const validateTimeField = (value, fieldName) => {
  if (!value) {
    return `${fieldName} is required`;
  }
  return "";
};

export const validateslaTarget = (value) => {
  if (!value || !value.trim()) {
    return "SLA is required";
  }
  return "";
};

export const validateAssignTo = (value) => {
  if (!value || value === "Select assignee") {
    return "Assign To is required";
  }
  return "";
};
export const validateUser = (value) => {
  if (!value || value === "Choose user") {
    return "Select User is required";
  }
  return "";
};

export const validateEventDescription = (value) => {
  if (!value || !value.trim()) {
    return "Event Description is required";
  }
  if (value.trim().length > 250) {
    return "Event Description must be less than 250 characters";
  }
  return "";
};

export const validateActionTaken = (value) => {
  if (!value || !value.trim()) {
    return "Action Taken is required";
  }
  if (value.trim().length > 250) {
    return "Action Taken must be less than 250 characters";
  }
  return "";
};

export const validateRootCause = (value) => {
  if (!value || !value.trim()) {
    return "Root Cause is required";
  }
  if (value.trim().length > 250) {
    return "Action Taken must be less than 250 characters";
  }
  return "";
};

export const validationEndDate = (value) => {
  if (!value) {
    return "Resolution end Date & Time is required";
  }

  const selectedDateTime = new Date(value);
  const currentDateTime = new Date();

  if (isNaN(selectedDateTime.getTime())) {
    return "Please enter a valid date and time";
  }

  if (selectedDateTime > currentDateTime) {
    return "Resolution Date & Time cannot be in the future";
  }

  return "";
};

export const validationStartDate = (value) => {
  if (!value) {
    return "Resolution end Date & Time is required";
  }

  const selectedDateTime = new Date(value);
  const currentDateTime = new Date();

  if (isNaN(selectedDateTime.getTime())) {
    return "Please enter a valid date and time";
  }

  if (selectedDateTime > currentDateTime) {
    return "Resolution Date & Time cannot be in the future";
  }

  return "";
};
